import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { MobilityKind } from '../../../../api/types';

const useMobilityTypeOptions = () => {
    const { t } = useTranslation(['mobilityDetails']);

    return useMemo(
        () => [
            {
                value: MobilityKind.Addon,
                label: t('mobilityDetails:options.addon'),
            },
            {
                value: MobilityKind.AdditionalInfo,
                label: t('mobilityDetails:options.additionalInfo'),
            },
        ],
        [t]
    );
};

export default useMobilityTypeOptions;
